// Popup-blocker-safe PDF opening.
//
// window.open() only escapes the popup blocker when it runs inside the user's
// click. If you fetch the PDF first (await) and THEN call window.open(), the
// browser has lost the "user gesture" and default popup blockers block the tab
// silently — so it opens on machines where popups are allowed for the site, and
// does nothing on machines with default settings.
//
// Fix: call openPdfWindow() SYNCHRONOUSLY in the click handler to claim the tab,
// then call .show(blob) after the fetch resolves. If the tab was blocked anyway,
// .show() downloads the file instead (downloads are never popup-blocked), so the
// user always gets the PDF.
export function openPdfWindow() {
  let win = null;
  try { win = window.open("", "_blank"); } catch { win = null; }
  if (win) {
    try {
      win.document.write(
        '<title>Loading…</title><body style="font-family:sans-serif;margin:0">' +
        '<p style="padding:24px;color:#555">Loading PDF…</p></body>'
      );
    } catch { /* cross-origin write guard */ }
  }
  return {
    // Show the fetched PDF. Returns true if it opened in the tab, false if it
    // fell back to a download (popup was blocked).
    show(blob, filename = "labels.pdf") {
      const url = URL.createObjectURL(blob);
      const opened = !!(win && !win.closed);
      if (opened) {
        try { win.location.href = url; }
        catch { downloadUrl(url, filename); }
      } else {
        downloadUrl(url, filename);
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return opened;
    },
    // Abort: close the placeholder tab (e.g. the fetch failed / found nothing).
    fail() { if (win && !win.closed) { try { win.close(); } catch { /* ignore */ } } },
  };
}

function downloadUrl(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
